const initialState = {
  transactions: [],
  createModalActive: false,
  createFormState: {
    data: {},
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_TRANSACTIONS': {
      const { transactions } = payload;
      return {
        ...state,
        transactions,
      };
    }
    case 'TOGGLE_MODAL': {
      const { active } = payload;
      return {
        ...state,
        createModalActive: active,
        createFormState: initialState.createFormState,
      };
    }
    case 'ON_TRANSACTION_CREATE_FORM_UPDATE': {
      const { formState } = payload;
      return {
        ...state,
        createFormState: formState,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/Ledger.reducer.js